var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 217,
    viewBox: "0 0 218 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.584 4.24264L106.998 2.82843L107.53 3.36048L107.53 3.36045L108.944 4.77466L109.827 5.65686L125.969 21.7993L127.383 23.2135L124.555 26.0419L123.141 24.6277L108.998 10.4852L108.998 67.3712H104.998L104.998 10.4853L90.8557 24.6277L89.4415 26.0419L86.613 23.2135L88.0273 21.7993L105.584 4.24264Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.172 103.145L214.587 104.559L214.055 105.091L212.64 106.505L211.758 107.387L195.616 123.53L194.201 124.944L191.373 122.116L192.787 120.701L206.93 106.559L150.044 106.559L150.044 102.559L206.93 102.559L192.787 88.4164L191.373 87.0022L194.202 84.1738L195.616 85.588L213.172 103.145Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24258 106.583L2.82837 105.169L3.36045 104.637L4.77466 103.222L5.6568 102.34L21.7993 86.1978L23.2135 84.7836L26.0419 87.612L24.6277 89.0263L10.4852 103.169L67.3711 103.169L67.3711 107.169L10.4852 107.169L24.6277 121.311L26.0419 122.725L23.2135 125.554L21.7992 124.14L4.24258 106.583Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.412 212.172L106.998 213.586L106.466 213.054L106.466 213.054L105.052 211.64L104.17 210.758L88.0272 194.615L86.613 193.201L89.4414 190.373L90.8557 191.787L104.998 205.93L104.998 149.044L108.998 149.044L108.998 205.929L123.141 191.787L124.555 190.373L127.383 193.201L125.969 194.615L108.412 212.172Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroDrag);
export default __webpack_public_path__ + "static/media/intro_drag.409c70c09b34e720f619afc7fb34e589.svg";
export { ForwardRef as ReactComponent };